var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTeamworkBadgeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 103,
    viewBox: "0 0 95 103",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_1767_5188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M44.2872 7.6762C46.1222 6.6364 48.3684 6.6364 50.2033 7.6762L79.0568 24.0263C80.9368 25.0916 82.0987 27.0855 82.0987 29.2464V61.7536C82.0987 63.9145 80.9368 65.9084 79.0568 66.9738L50.2033 83.3238C48.3684 84.3636 46.1222 84.3636 44.2872 83.3238L15.4338 66.9737C13.5538 65.9084 12.3918 63.9145 12.3918 61.7536V29.2464C12.3918 27.0855 13.5538 25.0916 15.4338 24.0262L44.2872 7.6762Z",
    fill: "url(#paint0_linear_1767_5188)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1767_5188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M66.6225 42.272C66.6225 43.924 66.2251 45.6956 65.4394 47.5387C65.1879 48.1287 64.6149 48.4842 64.011 48.4842C63.8076 48.4842 63.601 48.4439 63.4023 48.3585C62.612 48.0231 62.2456 47.1101 62.5825 46.3214C63.202 44.865 63.5172 43.5033 63.5172 42.272C63.5172 38.0643 60.3171 34.5086 56.5302 34.5086C53.0599 34.5086 51.0834 35.9138 49.7512 37.1389L43.8138 42.6493C43.2657 43.1989 43.1353 44.1228 43.5607 44.7144C43.8386 45.101 44.247 45.3339 44.7081 45.3711C45.1662 45.4131 45.6102 45.2454 45.9316 44.9209L52.4109 38.7179C53.0258 38.1264 54.0117 38.1465 54.6064 38.7661C55.1995 39.3856 55.1778 40.3684 54.5583 40.9615L52.6361 42.8015L60.0066 49.2699C61.7332 50.7853 62.1586 53.3301 60.9957 55.1887C60.2799 56.3315 59.1107 57.1 57.7894 57.2941C57.6993 57.3065 57.6108 57.3174 57.5208 57.3252C57.5146 58.1248 57.3019 58.9167 56.8656 59.6154C56.1498 60.7581 54.9806 61.5267 53.6593 61.7208C53.372 61.7611 53.0863 61.7782 52.8007 61.7643C52.7168 62.3574 52.515 62.935 52.1873 63.4582C51.4716 64.601 50.3179 65.6118 48.3181 65.6118C47.2203 65.6118 46.1552 65.2158 45.3199 64.4814L40.5004 60.1588C35.4154 55.5629 29.3584 48.7327 29.3584 42.272C29.3584 36.2787 33.886 31.4033 39.4508 31.4033C40.7333 31.4033 41.9863 31.6641 43.1725 32.1796C43.9597 32.5212 44.3215 33.4357 43.9799 34.2214C43.6383 35.007 42.7238 35.3673 41.9382 35.0288C41.1432 34.6841 40.3063 34.5102 39.4492 34.5102C35.6623 34.5102 32.4622 38.0658 32.4622 42.2736C32.4622 46.4254 36.0535 51.9576 42.5779 57.8531L47.3818 62.1602C47.6877 62.4288 48.1116 62.553 48.5308 62.4925C48.9562 62.4304 49.3211 62.1897 49.5556 61.8124C49.9127 61.2394 49.7357 60.3886 49.1503 59.8762L44.1709 55.1421C43.5514 54.5521 43.525 53.5708 44.1134 52.9482C44.7035 52.3271 45.6848 52.3007 46.3074 52.8876L52.0864 58.3437C52.3644 58.5859 52.7944 58.7133 53.2075 58.648C53.6329 58.5859 53.9978 58.3437 54.2322 57.968C54.5893 57.395 54.4123 56.5442 53.827 56.0302L48.2995 51.026C47.666 50.453 47.6147 49.4733 48.1861 48.8383C48.7559 48.2032 49.7357 48.1473 50.3738 48.7156L56.1839 53.886C56.4945 54.1593 56.9199 54.2866 57.3376 54.2214C57.763 54.1593 58.1279 53.917 58.3623 53.5413C58.7194 52.9684 58.5424 52.1175 57.9571 51.6036L50.3831 44.9566L48.1007 47.1412C47.1582 48.0852 45.8276 48.5758 44.455 48.4672C43.0918 48.3569 41.845 47.6505 41.0376 46.5279C39.7256 44.705 39.9911 42.0764 41.6556 40.4119L47.6411 34.8564C49.259 33.3705 51.9327 31.4017 56.5271 31.4017C62.0918 31.4017 66.6194 36.2771 66.6194 42.2704L66.6225 42.272Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_1767_5188",
    x: 0.391846,
    y: 0.896362,
    width: 93.7068,
    height: 101.207,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1767_5188"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1767_5188"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1767_5188",
    result: "effect2_dropShadow_1767_5188"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1767_5188",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1767_5188",
    x1: 27.5333,
    y1: 18.3438,
    x2: 67.0587,
    y2: 74.2303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2F6E79"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#54C4D7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1767_5188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 37.2641,
    height: 37.2641,
    fill: "white",
    transform: "translate(29.3584 29.8491)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamworkBadgeIcon);
export default __webpack_public_path__ + "static/media/teamwork-badge-icon.e078c2af37e4cb2d45c9928c002f8eee.svg";
export { ForwardRef as ReactComponent };